import React from "react";
import { TitleLayout } from "~/apps/core/ui/TitleLayout";
import {Box} from "@mui/material";
import {OrderDetail} from "~/apps/packages/auto-shipment-orders/components/OrderDetail/OrderDetail";
import {useParams} from "react-router-dom";
import {useAutoShipmentOrder} from "~/apps/packages/auto-shipment-orders/hooks";
import {LoadingBox} from "~/apps/core/ui/LoadingBox";

export const DetailPage = () => {
    const {id} = useParams<{ id: string }>();
    const {data, loading} = useAutoShipmentOrder(id);

    return (
        <TitleLayout title="Наряд на авто">
            <LoadingBox loading={loading}>
                <Box pt={2}>
                    {data && <OrderDetail
                        order={data}

                    />}
                </Box>
            </LoadingBox>
        </TitleLayout>
    );
}
